import { IconProps } from './icons-props';

function GalleryIcon({ className, width = 18, height = 18 }: IconProps) {
    return (
        <>
            <svg
                className={className}
                width={width}
                height={height}
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H11.25C15.3225 0.9375 17.0625 2.6775 17.0625 6.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625ZM6.75 2.0625C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V6.75C15.9375 3.2925 14.7075 2.0625 11.25 2.0625H6.75Z'
                    fill='currentColor'
                />
                <path
                    d='M6.75 8.0625C5.61 8.0625 4.6875 7.14 4.6875 6C4.6875 4.86 5.61 3.9375 6.75 3.9375C7.89 3.9375 8.8125 4.86 8.8125 6C8.8125 7.14 7.89 8.0625 6.75 8.0625ZM6.75 5.0625C6.2325 5.0625 5.8125 5.4825 5.8125 6C5.8125 6.5175 6.2325 6.9375 6.75 6.9375C7.2675 6.9375 7.6875 6.5175 7.6875 6C7.6875 5.4825 7.2675 5.0625 6.75 5.0625Z'
                    fill='currentColor'
                />
                <path
                    d='M2.00257 14.7749C1.82257 14.7749 1.64257 14.6849 1.53757 14.5274C1.36507 14.2724 1.43257 13.9199 1.69507 13.7474L5.39257 11.2649C6.20257 10.7174 7.32007 10.7849 8.05507 11.4074L8.30257 11.6249C8.67757 11.9474 9.31507 11.9474 9.68257 11.6249L12.8026 8.94742C13.5976 8.26492 14.8501 8.26492 15.6526 8.94742L16.8751 9.99742C17.1076 10.1999 17.1376 10.5524 16.9351 10.7924C16.7326 11.0249 16.3801 11.0549 16.1401 10.8524L14.9176 9.80242C14.5426 9.47992 13.9051 9.47992 13.5301 9.80242L10.4101 12.4799C9.61507 13.1624 8.36257 13.1624 7.56007 12.4799L7.31257 12.2624C6.96757 11.9699 6.39757 11.9399 6.01507 12.2024L2.31757 14.6849C2.22007 14.7449 2.10757 14.7749 2.00257 14.7749Z'
                    fill='currentColor'
                />
            </svg>
        </>
    );
}

export default GalleryIcon;

